import React from "react";
import styled from "styled-components";
import contactBg from "../../assets//images/contact-bg.png";

// se llamaba .faq-section
const WrapperFaqs = styled.section`
  padding: 40px 0;
  position: relative;
  background-image: url(${contactBg});
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  h1 {
    color: #5268c2;
    font-weight: 700;
    font-size: 40px;
    margin-bottom: 20px;
  }

  p {
    color: #5268c2;
  }

  .faq-list {
    min-height: 50vh;
  }

  .card {
    border: none;
    border-radius: 15px;

    .card-header {
      background: #5268c2;
      padding: 10px 10px 0;
      border: none;
      border-radius: 15px 15px 0px 0px;
    }
  }

  .nav-tabs {
    border-bottom: none;

    .nav-link {
      background: #a9b5e5;
      min-width: 180px;
      margin-right: 15px;
      border-radius: 10px 10px 0 0;
      color: #5268c2;
      font-weight: 600;
      padding: 6px 15px;
      margin-bottom: 0px;
    }

    .nav-item.show .nav-link,
    .nav-link.active,
    .nav-link:hover {
      background: #fff;
    }
  }

  .accordion {
    box-shadow: none;

    .accordion-header {
      background: transparent;
      border-top: 1px solid #d0d0d0;
      padding: 0;
    }

    .accordion-body {
      padding: 15px 30px;
      font-size: 14px;
      p {
        text-align: left;
        color: #8e8e8e;
      }
    }
  }

  .accordion-button {
    color: #8e8e8e;
    font-size: 14px;
    padding: 13px 30px;
    border-radius: 0;
  }
`;

export default WrapperFaqs;
